export default "__VITE_ASSET__D1KHHeje__"